// DTO for cancellable item data received from supplier APIs (e.g., Uniformax)
// Plain interface (not a Breeze entity) used for API responses

export interface CancellableDetailDTO {
  proximityJoDetailId: string;
  joHeaderId: number;
  orderQty: number;
  cancellableQty: number;
  requiresAdminApproval: boolean;
  reason?: string;
}
